import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "skeleton-body" }
const _hoisted_3 = {
  key: 0,
  class: "toolbox sticky-header horizontal-filter filter-sorts"
}
const _hoisted_4 = { class: "col-sm-6 top-pagination" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "toolbox-item layout-modes" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-mode-list" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-mode-grid" }, null, -1)
const _hoisted_9 = { class: "row divide-line no-gutters m-0" }
const _hoisted_10 = {
  key: 1,
  class: "info-box p-0 shop-info mb-2 no-items-area"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "No items were found matching your selection.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skel-group" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "tab-content col-lg-12" })
  ])
], -1)
const _hoisted_13 = {
  class: "skel-pro mb-2",
  key: "normalSkel"
}
const _hoisted_14 = {
  key: 1,
  class: "skel-pro skel-pro-list mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_per_page = _resolveComponent("v-per-page")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_base_select = _resolveComponent("v-base-select")!
  const _component_product_grid_card = _resolveComponent("product-grid-card")!
  const _component_product_list_card = _resolveComponent("product-list-card")!
  const _component_fa = _resolveComponent("fa")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_b_col, {
                  md: "12",
                  lg: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, { md: "12" }, {
                          default: _withCtx(() => [
                            (_ctx.pagination)
                              ? (_openBlock(), _createBlock(_component_v_per_page, {
                                  key: 0,
                                  currentPage: _ctx.currentPage,
                                  pagination: _ctx.pagination,
                                  onUpdatedLimit: _ctx.onUpdatedLimit,
                                  onUpdatedPage: _ctx.onUpdatedPage
                                }, null, 8, ["currentPage", "pagination", "onUpdatedLimit", "onUpdatedPage"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    to: { path: '/shop', query: _ctx.$route.query },
                    class: _normalizeClass(["layout-btn btn-list", { active: _ctx.type === 'list' }]),
                    title: "List"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["to", "class"]),
                  _createVNode(_component_router_link, {
                    to: { path: '/shop/grid', query: _ctx.$route.query },
                    class: _normalizeClass(["layout-btn btn-grid", { active: _ctx.type === 'grid' }]),
                    title: "Grid"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["to", "class"])
                ]),
                _createVNode(_component_v_base_select, {
                  sort: _ctx.sort,
                  items: _ctx.sorting.sortOptions,
                  placeholder: "-- Sort Results --",
                  onItemsSearch: _ctx.onItemsSearch,
                  searchKey: "sorting"
                }, null, 8, ["sort", "items", "onItemsSearch"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.items && _ctx.items.length > 0 && !_ctx.loading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.items, (product, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'shop-product' + index,
                  class: _normalizeClass({ 'col-12': _ctx.type === 'list', 'col-6 col-sm-4': _ctx.type === 'grid' })
                }, [
                  (_ctx.type === 'grid')
                    ? (_openBlock(), _createBlock(_component_product_grid_card, {
                        product: product,
                        key: "gridType"
                      }, null, 8, ["product"]))
                    : (_openBlock(), _createBlock(_component_product_list_card, {
                        key: 1,
                        product: product
                      }, null, 8, ["product"]))
                ], 2))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.items && _ctx.items.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_fa, { icon: "magnifying-glass" }),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repeatCount.slice(0, _ctx.perPage), (_item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([{ 'col-12': _ctx.type === 'list', 'col-6 col-sm-4': _ctx.type === 'grid' }, "skeleton-body"]),
                    key: 'skel-shop' + index
                  }, [
                    (_ctx.type === 'grid')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14))
                  ], 2))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_b_col, {
            md: "12",
            lg: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { md: "12" }, {
                    default: _withCtx(() => [
                      (_ctx.pagination)
                        ? (_openBlock(), _createBlock(_component_v_per_page, {
                            key: 0,
                            currentPage: _ctx.currentPage,
                            pagination: _ctx.pagination,
                            onUpdatedLimit: _ctx.onUpdatedLimit,
                            onUpdatedPage: _ctx.onUpdatedPage
                          }, null, 8, ["currentPage", "pagination", "onUpdatedLimit", "onUpdatedPage"]))
                        : _createCommentVNode("", true),
                      (_ctx.pagination)
                        ? (_openBlock(), _createBlock(_component_v_pagination, {
                            key: 1,
                            currentPage: _ctx.currentPage,
                            pagination: _ctx.pagination,
                            "total-rows": _ctx.rows,
                            "per-page": _ctx.perPage,
                            onUpdatedPage: _ctx.onUpdatedPage
                          }, null, 8, ["currentPage", "pagination", "total-rows", "per-page", "onUpdatedPage"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}